import { render, staticRenderFns } from "./StudyItem.vue?vue&type=template&id=701ea192&scoped=true"
import script from "./StudyItem.vue?vue&type=script&lang=js"
export * from "./StudyItem.vue?vue&type=script&lang=js"
import style0 from "./StudyItem.vue?vue&type=style&index=0&id=701ea192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701ea192",
  null
  
)

export default component.exports